import {
	Breadcrumbs,
	Divider,
	Tabs,
	Tab,
	Typography,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { LinkEmpresas } from "src/components/CheckPro/Links";
import { LinkProjectsOT } from "src/components/CheckPro/Links/NeoProjects";
import { RevisionGoalGraphOT } from "src/components/ProjectsOT/Graph/RevisionGoal";
import { useBusiness } from "src/hooks/redux/useBusiness";
import { useProjectsOT } from "src/hooks/redux/useProjectsOT";

export const RevisionGoalGraphPageOT = () => {
	const { selectedBusiness } = useBusiness();
	const { selected, get, project } = useProjectsOT();

	const [type, setType] = useState<
		"Obra Gruesa" | "Terminaciones"
	>("Obra Gruesa");

	useEffect(() => {
		if (!selected.project) return;
		get.project.checklists(type);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selected.project, type]);

	useEffect(() => {
		if (!project.checklists) return;
		get.report.projectRevisionGoals();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [project.checklists]);

	return (
		<>
			<Helmet title="Checklist" />

			<Breadcrumbs style={{ fontSize: 20 }}>
				<Typography variant="h3" style={{ color: "black" }}>
					{selectedBusiness?.Nombre ?? "Empresa"}
				</Typography>
				<Typography variant="h3" style={{ color: "black" }}>
					{selected.project?.Nombre ?? "Proyecto"}
				</Typography>
			</Breadcrumbs>

			<Breadcrumbs>
				<LinkEmpresas />
				<LinkProjectsOT />
				<Typography>Metas de revisión</Typography>
			</Breadcrumbs>

			<Divider
				style={{ marginTop: 10, marginBottom: 10 }}
			/>

			<Tabs
				value={type}
				onChange={(e, v) => setType(v)}
				variant="fullWidth"
			>
				<Tab label="Obra Gruesa" value="Obra Gruesa" />
				<Tab label="Terminaciones" value="Terminaciones" />
			</Tabs>

			<RevisionGoalGraphOT />
		</>
	);
};
